import { createSlice } from "@reduxjs/toolkit";
import { fetchDispatchMonitoring } from "./thunk";

interface DispatchMonitoringState {
  dispatch_done_count: number;
  stock_transfer_count: number;
  issue_to_labour_count: number;
  total: number;
  loading: boolean;
  error: string | null;
}

const initialState: DispatchMonitoringState = {
  dispatch_done_count: 0,
  stock_transfer_count: 0,
  issue_to_labour_count: 0,
  total: 0,
  loading: false,
  error: null,
};

const dispatchMonitoringSlice = createSlice({
  name: "dispatchMonitoring",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDispatchMonitoring.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDispatchMonitoring.fulfilled, (state, action) => {
        state.loading = false;
        state.dispatch_done_count = action.payload.dispatch_done_count;
        state.stock_transfer_count = action.payload.stock_transfer_count;
        state.issue_to_labour_count = action.payload.issue_to_labour_count;
        state.total = action.payload.total;
      })
      .addCase(fetchDispatchMonitoring.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch dispatch monitoring data";
      });
  },
});

export default dispatchMonitoringSlice.reducer;

